import { FilterOperators } from '@kirin/api-client/contracts/table';
import {
  DEVICE_FILTERABLE_FIELDS,
  type DeviceFilterableField,
  type DeviceOsFamily,
  type DevicePersonIdentity,
} from '@kirin/api-client/contracts/device-inventory';

export const DEVICES_TABLE_CONFIG = {
  tableId: 'org-dev',
  defaultOperator: FilterOperators.INCLUDES,
} as const;

/** URL key per filter field; `satisfies` keeps it exhaustive. */
export const DEVICE_FILTER_URL_KEYS = {
  [DEVICE_FILTERABLE_FIELDS.ENDPOINT]: 'ep',
  [DEVICE_FILTERABLE_FIELDS.OS]: 'os',
  [DEVICE_FILTERABLE_FIELDS.AGENT_VERSION]: 'av',
  [DEVICE_FILTERABLE_FIELDS.UPDATE_STATE]: 'us',
  [DEVICE_FILTERABLE_FIELDS.SHARED]: 'sh',
} as const satisfies Record<DeviceFilterableField, string>;

export const OS_FAMILY_LABELS: Record<DeviceOsFamily, string> = {
  windows: 'Windows',
  macos: 'macOS',
  linux: 'Linux',
  unknown: 'Unknown',
};

/** Decided labels (KIR-5336): Member / Discovered / Unattributed / Offboarded. */
export const IDENTITY_LABELS: Record<DevicePersonIdentity, string> = {
  member: 'Member',
  discovered: 'Discovered',
  unattributed: 'Unattributed',
  offboarded: 'Offboarded',
};

export const IDENTITY_DESCRIPTIONS: Record<DevicePersonIdentity, string> = {
  member: 'A user of your organization.',
  discovered:
    'Known only by email. This person has no Kirin account in your organization.',
  unattributed: 'Kirin could not tell who this person is.',
  offboarded:
    'Removed from your organization, and still seen on this endpoint.',
};

/**
 * KIR-5670: an Unattributed person that is the machine's shared Guest / kiosk
 * sessions. Shown instead of "Unattributed"; never offered "Link to user".
 */
export const GUEST_LABEL = 'Guest';
export const GUEST_DESCRIPTION =
  "Guest or kiosk sessions on this computer, shared by everyone who signs in that way. They stay protected, but can't be linked to a user.";

/** Shared-filter values the backend accepts (`shared[includes]=true`). */
export const SHARED_FILTER_VALUES = {
  shared: 'true',
  single: 'false',
} as const;
